/**
 * Segundo factor — `OD-0026 D-05`.
 *
 * La API responde `UNAUTHENTICATED` tanto si el código es incorrecto como si
 * el reto ha caducado. Aquí no se adivina cuál de los dos es: se muestra el
 * mensaje del código y se ofrece volver a empezar, que es lo que resuelve el
 * caso del reto caducado.
 */
import { useState } from "react";
import { api } from "../api/cliente";
import { t } from "../i18n/es";
import { Aviso, Boton, Campo, Tarjeta } from "../ui/primitivas";

export function PantallaMfa({
  challenge,
  hayConexion,
  onAutenticado,
  onVolver,
}: {
  challenge: string;
  hayConexion: boolean;
  onAutenticado: () => void;
  onVolver: () => void;
}) {
  const [codigo, setCodigo] = useState("");
  const [errorCodigo, setErrorCodigo] = useState<string | null>(null);
  const [errorGeneral, setErrorGeneral] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setErrorGeneral(null);
    if (codigo.trim() === "") {
      setErrorCodigo(t.mfa.faltaCodigo);
      return;
    }
    setErrorCodigo(null);

    setEnviando(true);
    const r = await api.loginMfa(challenge, codigo.trim());
    setEnviando(false);

    if (r.ok) {
      if (r.datos.tipo === "AUTENTICADO") {
        onAutenticado();
        return;
      }
      // La API no puede pedir MFA otra vez en este paso. Si lo hiciera, es un
      // defecto: no se inventa una pantalla nueva, se dice que algo ha fallado.
      setErrorGeneral(t.login.errorGenerico);
      return;
    }
    if (r.estado === 0) setErrorGeneral(t.login.sinRed);
    else if (r.estado === 401) setErrorGeneral(t.mfa.codigoIncorrecto);
    else if (r.estado === 429) setErrorGeneral(t.login.demasiadosIntentos);
    else setErrorGeneral(t.login.errorGenerico);
  }

  return (
    <Tarjeta titulo={t.mfa.titulo}>
      <form onSubmit={enviar} noValidate>
        <Campo
          id="codigo"
          etiqueta={t.mfa.codigo}
          valor={codigo}
          onChange={setCodigo}
          inputMode="numeric"
          autoComplete="one-time-code"
          error={errorCodigo}
          autoFocus
        />
        {errorGeneral !== null ? <Aviso tono="error">{errorGeneral}</Aviso> : null}
        <Boton tipo="submit" deshabilitado={enviando || !hayConexion}>
          {enviando ? t.mfa.verificando : t.mfa.verificar}
        </Boton>
      </form>
      <Aviso tono="info">{t.mfa.detalle}</Aviso>
      <Boton variante="secundario" onClick={onVolver}>
        {t.mfa.volver}
      </Boton>
    </Tarjeta>
  );
}
